import * as React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextArea from 'components/form/TextArea';
import { TextAreaProps } from 'components/form/TextArea/TextArea';

interface Props extends Omit<TextAreaProps, 'name'> {
  name: string;
  handlePasswordChange?: (pw: string, isKnownPassword: boolean) => void;
}

const RHFTextArea: React.FC<Props> = props => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextArea
          {...field}
          onChange={value => field.onChange(value)}
          error={!!error}
          helperText={error?.message}
          {...props}
        />
      )}
    />
  );
};

export default RHFTextArea;
